import { FC } from 'react';

import styles from './Placeholder.module.css';

import LoadingSpinner from '../LoadingSpinner';

export type Props = {};

export const Placeholder: FC<Props> = () => {
  return (
    <div className={styles.feedsGetStartedPlaceholder}>
      <LoadingSpinner
        className={styles.getStartedLoading}
        size={30}
        color="blue"
      />
      <span className={styles.feedsGetStartedPlaceholderInfo}>
        Waiting for activity
      </span>
    </div>
  );
};
